import React, { Component } from 'react';
import {
	Modal,
	Form,
	Input,
	Checkbox,
	Button,
	// Icon,
	Select,
	message,
} from 'antd';
import { connect } from 'react-redux';
import { SetupBizAction } from '../../actions';
import { bindActionCreators } from 'redux';
import Wrapper from './style';
import { GENERAL, WITHDRAWAL } from './fields.json';
import { previewFile } from '../../common/utils';

const { Item } = Form;
const { Option } = Select;

const DEFAULT_TEMPLATE = {
	ASSET_NAME: '',
	ASSET_SYMBOL: '',
	ASSET_COLOR: '',
	ASSET_ALLOW_DEPOSITS: true,
	ASSET_ALLOW_WITHDRAWAL: true,
	ASSET_PROMOTE: false,
	ASSET_WITHDRAWAL_FEE: 0.001,
	ASSET_MINIMUM_WITHDRAWAL: 0.001,
	ASSET_MAXIMUM_WITHDRAWAL: 10000,
	ASSET_INCREMENT_AMOUNT: 0.001,
	ASSET_ACTIVATE: true,
	ASSET_ICON: '',
	deposit: {},
	withdraw: {},
};

class AssetFormModal extends Component {
	state = {
		ASSET_COLOR: '#22194D',
		isLoaded: false,
		icon: '',
		iconName: '',
		isOpenWithdrawal: false,
		isOpenLimits: false,
	};

	tiers = [];

	componentWillMount() {
		const { tiers } = this.props;
		this.tiers = [];
		for (let index = 0; index < tiers; index++) {
			const tier = {
				key: index + 1,
				value: 'Tier ' + (index + 1),
			};
			this.tiers.push(tier);
		}
		this.setState({
			isLoaded: true,
		});
	}

	componentDidMount() {
		const { state, currency } = this.props;
		const { setFieldsValue } = this.props.form;
		const isNew = state.ASSETS.filter((item) => {
			return item.ASSET_SYMBOL.toLowerCase() === currency;
		});
		if (isNew.length === 0) {
			const data = DEFAULT_TEMPLATE;
			for (
				let index = 1;
				index <= parseInt(state.ACCOUNT_TIERS, 10);
				index++
			) {
				data[`deposit${index}`] = '0';
				data[`withdraw${index}`] = '0';
			}
			setFieldsValue(data);
			this.setState(data);
		} else {
			const data = state.ASSETS.filter((item) => {
				return item.ASSET_SYMBOL.toLowerCase() === currency;
			});

			for (
				let index = 1;
				index <= parseInt(state.ACCOUNT_TIERS, 10);
				index++
			) {
				data[0][`deposit${index}`] = data[0].deposit[`${index}`];
				data[0][`withdraw${index}`] = data[0].withdraw[`${index}`];
			}
			setFieldsValue(data[0]);
			this.setState(data[0]);
		}
	}

	handleSubmit = (e) => {
		e.preventDefault();
		const { onOk, actions, currency, state, isNew } = this.props;
		const { getFieldValue } = this.props.form;
		const body = {
			deposit: {},
			withdraw: {},
		};
		let isOkay = true;
		if (!getFieldValue('ASSET_NAME') || getFieldValue('ASSET_NAME') === '') {
			message.warn('Please Input Asset Name');
			return;
		}
		if (
			!getFieldValue('ASSET_SYMBOL') ||
			getFieldValue('ASSET_SYMBOL') === ''
		) {
			message.warn('Please Input Asset Symbol');
			return;
		}

		if (getFieldValue('ASSET_SYMBOL').length > 4) {
			message.warn('The symbol should not be more than 4 characters');
			return;
		}
		state.ASSETS.forEach((item) => {
			if (
				item.ASSET_SYMBOL.toLowerCase() ===
				getFieldValue('ASSET_SYMBOL').toLowerCase()
			) {
				isOkay = false;
			}
		});
		if (!isOkay && isNew) {
			message.warn('You aleady have a same symbol name');
			return;
		}
		state.ASSETS.forEach((item) => {
			if (
				item.ASSET_NAME.toLowerCase() ===
				getFieldValue('ASSET_NAME').toLowerCase()
			) {
				isOkay = false;
			}
		});
		if (!isOkay && isNew) {
			message.warn('You aleady have a same name');
			return;
		}
		GENERAL.forEach((item) => {
			body[item.key] = getFieldValue(item.key);
		});
		WITHDRAWAL.forEach((item) => {
			body[item.key] = getFieldValue(item.key);
		});
		body.ASSET_SYMBOL = body.ASSET_SYMBOL.toLowerCase();

		this.tiers.forEach((item, index) => {
			body.deposit[index + 1] = `${this.state[`deposit${item.key}`]}`;
			body.withdraw[index + 1] = `${this.state[`withdraw${item.key}`]}`;
		});

		body.ASSET_ACTIVATE = getFieldValue('ASSET_ACTIVATE');
		body.ASSET_ALLOW_DEPOSITS = getFieldValue('ASSET_ALLOW_DEPOSITS');
		body.ASSET_ALLOW_WITHDRAWAL = getFieldValue('ASSET_ALLOW_WITHDRAWAL');
		const newData = {};
		const newOne = state.ASSETS.filter((item) => {
			return item.ASSET_SYMBOL.toLowerCase() === currency;
		});
		if (newOne.length === 0) {
			newData.ASSETS = state.ASSETS.concat([]);
			newData.ASSETS.push(body);
		} else {
			newData.ASSETS = state.ASSETS.map((item) => {
				if (item.ASSET_SYMBOL.toLowerCase() === currency) {
					return body;
				}
				return item;
			});
		}
		actions.updateData(newData);
		onOk();
	};

	handleChangeFile = async (e) => {
		const { files } = e.target;
		try {
			const res = await previewFile(files[0]);
			this.setState({
				iconName: files[0].name,
				icon: res,
			});
		} catch (error) {
			console.error(error);
		}
	};

	handleSelect = (v, name) => {
		this.setState({ [name]: v });
	};

	handleChangeInput = (e) => {
		const { getFieldValue } = this.props.form;
		const { name, value } = e.target;
		const maximum = getFieldValue('ASSET_MAXIMUM_WITHDRAWAL');
		if (
			name.indexOf('withdraw') >= 0 &&
			parseFloat(maximum) < parseFloat(value)
		) {
			this.setState({ [name]: parseFloat(maximum) });
			return;
		}
		this.setState({ [name]: value });
	};

	handleColor = (color) => {
		this.setState({ ASSET_COLOR: color });
	};

	renderFields = () => {
		const { currency } = this.props;
		const { getFieldDecorator, getFieldValue } = this.props.form;
		const List = GENERAL.map((item) => {
			if (item.type === 'text') {
				let symbol = '';
				if (item.currency) {
					symbol =
						currency === 'new'
							? getFieldValue('ASSET_SYMBOL')
							: currency.toUpperCase();
				}
				return (
					<Item key={item.key}>
						<h4>{item.title}</h4>
						<p>{item.description}</p>
						{getFieldDecorator(item.key)(
							<Input placeholder={item.placeHolder} suffix={symbol} />
						)}
					</Item>
				);
			} else if (item.type === 'check') {
				return (
					<Item key={item.key}>
						{getFieldDecorator(item.key, {
							valuePropName: 'checked',
							initialValue: false,
						})(
							<Checkbox>
								<div>
									<h4>{item.title}</h4>
									<p>{item.description}</p>
								</div>
							</Checkbox>
						)}
					</Item>
				);
			}
			return null;
		});
		return List;
	};

	renderWithdrawals = () => {
		const { currency } = this.props;
		const { getFieldDecorator, getFieldValue } = this.props.form;
		const List = WITHDRAWAL.map((item) => {
			if (item.type === 'text') {
				let symbol = '';
				if (item.currency) {
					symbol =
						currency === 'new'
							? getFieldValue('ASSET_SYMBOL')
							: currency.toUpperCase();
				}
				return (
					<Item key={item.key}>
						<h4>{item.title}</h4>
						<p>{item.description}</p>
						{getFieldDecorator(item.key)(
							<Input placeholder={item.placeHolder} suffix={symbol} />
						)}
					</Item>
				);
			} else if (item.type === 'check') {
				return (
					<Item key={item.key}>
						{getFieldDecorator(item.key, {
							valuePropName: 'checked',
							initialValue: false,
						})(
							<Checkbox>
								<div>
									<h4>{item.title}</h4>
									<p>{item.description}</p>
								</div>
							</Checkbox>
						)}
					</Item>
				);
			}
			return null;
		});
		return List;
	};

	renderLimits = () => {
		const { currency } = this.props;
		const List = this.tiers.map((item, index) => (
			<div className="tier-card">
				<h3>{item.value} Acoount</h3>
				<Item key={`deposit${index}`}>
					<h4>Deposit</h4>
					<p>
						Set this assets deposit amount for the account{' '}
						<b>{item.value}.</b>
					</p>
					<Select
						name={`deposit${item.key}`}
						value={this.state[`deposit${item.key}`]}
						onChange={(v) => {
							this.setState({ [`deposit${item.key}`]: v });
						}}
					>
						<Option value="0">Unlimited</Option>
						<Option value="-1">Disabled</Option>
						<Option value="1">Custom</Option>
					</Select>
					{parseInt(this.state[`deposit${item.key}`], 10) > 0 ? (
						<Input
							name={`deposit${item.key}`}
							value={this.state[`deposit${item.key}`]}
							onChange={this.handleChangeInput}
							placeholder="0.0"
							suffix={currency.toUpperCase()}
						/>
					) : null}
				</Item>
				<Item key={`withdraw${index}`}>
					<h4>Withdraw</h4>
					<p>
						Set this assets withdraw amount for the account{' '}
						<b>{item.value}.</b>
					</p>
					<Select
						name={`withdraw${item.key}`}
						value={this.state[`withdraw${item.key}`]}
						onChange={(v) => {
							this.setState({ [`withdraw${item.key}`]: v });
						}}
					>
						<Option value="0">Unlimited</Option>
						<Option value="-1">Disabled</Option>
						<Option value="1">Custom</Option>
					</Select>
					{parseInt(this.state[`withdraw${item.key}`], 10) > 0 ? (
						<Input
							name={`withdraw${item.key}`}
							value={this.state[`withdraw${item.key}`]}
							onChange={this.handleChangeInput}
							placeholder="0.0"
							suffix={currency.toUpperCase()}
						/>
					) : null}
				</Item>
			</div>
		));
		return List;
	};

	render() {
		const { isLoaded, isOpenWithdrawal, isOpenLimits } = this.state;
		const { visible, onCancel, title } = this.props;
		const { getFieldDecorator } = this.props.form;
		if (!isLoaded) {
			return null;
		}
		return (
			<Modal
				visible={visible}
				title={title}
				footer={null}
				onCancel={onCancel}
				wrapClassName="asset-form"
			>
				<Wrapper>
					<Form onSubmit={this.handleSubmit}>
						{this.renderFields()}
						<Item className="checkBox">
							<h4>Make Coin Active</h4>
							<p>
								Activate this coin on your exchange immediately after
								setup.
							</p>
							{getFieldDecorator('ASSET_ACTIVATE', {
								valuePropName: 'checked',
								initialValue: true,
							})(<Checkbox />)}
						</Item>
						<Item className="checkBox">
							<h4>Allow Deposits</h4>
							<p>
								Allow deposits for this coin once the exchange launches.
								Amount is dependents on user level and what you set
								later on.
							</p>
							{getFieldDecorator('ASSET_ALLOW_DEPOSITS', {
								valuePropName: 'checked',
								initialValue: true,
							})(<Checkbox />)}
						</Item>
						<Item className="checkBox">
							<h4>Allow Withdrawal</h4>
							<p>
								Allow withdrawal for this coin once the exchange
								launches. Amount is dependents on user level and what
								you set later on.
							</p>
							{getFieldDecorator('ASSET_ALLOW_WITHDRAWAL', {
								valuePropName: 'checked',
								initialValue: true,
							})(<Checkbox />)}
						</Item>
						<div
							className={
								isOpenWithdrawal ? 'drop-down active' : 'drop-down'
							}
						>
							<h3
								onClick={() => {
									this.setState({
										isOpenWithdrawal: !isOpenWithdrawal,
									});
								}}
							>
								General Withdraw
							</h3>
							{this.renderWithdrawals()}
						</div>
						<div
							className={isOpenLimits ? 'drop-down active' : 'drop-down'}
						>
							<h3
								onClick={() => {
									this.setState({ isOpenLimits: !isOpenLimits });
								}}
							>
								User Account Deposit & Withdraw Limits
							</h3>
							{this.renderLimits()}
						</div>

						<Button block type="primary" htmlType="submit">
							DONE
						</Button>
					</Form>
				</Wrapper>
			</Modal>
		);
	}
}

AssetFormModal.defaultProps = {
	title: 'Add an Asset',
	visible: false,
	tiers: 4,
	currency: 'btc',
	onOk: () => {},
	onCancel: () => {},
};

const WrappedAssetFormModal = Form.create({})(AssetFormModal);

const mapStateToProps = (state) => {
	return {
		state: state.biz,
	};
};

const mapDispatchToProps = (dispatch) => ({
	actions: bindActionCreators(SetupBizAction, dispatch),
});

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(WrappedAssetFormModal);
